import UpdateImage from './updateImage.svg';

export default UpdateImage;
